module.exports = __webpack_public_path__ + "img/123.7.6c922044.png";